<template>
  <div class="site-width">
    <h1 class="text-h4 text-center q-py-sm">
      {{ $t('Reset your password') }}
    </h1>
    <div
      v-if="done"
      class="text-center q-pa-sm"
    >
      <p>{{ $t('Request is sent. Please, check your inbox.') }}</p>
    </div>
    <form-forgot-password
      ref="form"
      @submit="onFormSubmit"
      :loading="isProcessing"
      v-else
      class="form form-forgot-password"
    />
  </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';

import { mapActions } from 'vuex';
import FormForgotPassword from '@/components/forms/FormForgotPassword';

@Component({
  name: 'page-forgot-password',
  components: {
    FormForgotPassword,
  },
  methods: mapActions(['userForgotPassword']),
})
export default class PageForgotPassword extends Vue {
  done = false;
  isProcessing = false;

  async onFormSubmit({ email }) {
    this.isProcessing = true;
    try {
      await this.userForgotPassword(email);
      this.done = true;
    } catch (error) {
      console.dir(error);
      this.$refs.form.setError(this.$t('errors.user_not_found'));
    }
    this.isProcessing = false;
  }
}
</script>
